import { render, staticRenderFns } from "./DkReadMoreDST.vue?vue&type=template&id=37719e59&"
import script from "./DkReadMoreDST.vue?vue&type=script&lang=js&"
export * from "./DkReadMoreDST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports